module.exports = __webpack_public_path__ + "i18n/de.b46780ee10bd38ffe082685443ad60bf.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/de.json
// module id = 1306
// module chunks = 59